class LpLivePrice extends HTMLElement {
  connectedCallback() {
    document.addEventListener("lp-bundle:change", this.#handleChange);

    // Same race-condition guard as lp-unlock-bar: read the currently
    // selected tier straight from the DOM in case the bundle selector's
    // own initial broadcast fires before this listener is registered.
    const selectedTier = document.querySelector(
      "[data-tier].lp-bundle-selector__tier--selected",
    );
    if (selectedTier instanceof HTMLElement) {
      this.#applyState({
        perBottle: selectedTier.dataset.perBottle || "",
        protocolName: selectedTier.dataset.protocolName || "",
        comparePrice: selectedTier.dataset.comparePrice || "",
        variantOption: selectedTier.dataset.variantOption || "",
        badgePercent: selectedTier.dataset.badgePercent || "",
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener("lp-bundle:change", this.#handleChange);
  }

  /**
   * @param {CustomEvent<{perBottle: string, protocolName: string, comparePrice: string, variantOption: string, badgePercent: string}>} event
   */
  #handleChange = (event) => {
    this.#applyState(event.detail);
  };

  /**
   * @param {{perBottle: string, protocolName: string, comparePrice: string, variantOption: string, badgePercent: string}} detail
   */
  #applyState({ perBottle, protocolName, comparePrice, variantOption, badgePercent }) {
    const current = this.querySelector("[data-current]");
    if (current && perBottle) current.textContent = perBottle;

    const compare = this.querySelector("[data-compare]");
    if (compare && comparePrice) compare.textContent = comparePrice;

    const protocol = this.querySelector("[data-protocol]");
    if (protocol && protocolName) protocol.textContent = protocolName;

    const size = this.querySelector("[data-size]");
    if (size && variantOption) size.textContent = variantOption;

    const badge = this.querySelector("[data-discount-badge]");
    if (badge instanceof HTMLElement) {
      const percent = Number(badgePercent) || 0;
      if (percent > 0) {
        badge.textContent = `-${percent}%`;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
  }
}

if (!customElements.get("lp-live-price")) {
  customElements.define("lp-live-price", LpLivePrice);
}
